import { render, staticRenderFns } from "./DepositDetails.vue?vue&type=template&id=7eab5151&scoped=true"
import script from "./DepositDetails.vue?vue&type=script&lang=js"
export * from "./DepositDetails.vue?vue&type=script&lang=js"
import style0 from "./DepositDetails.vue?vue&type=style&index=0&id=7eab5151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eab5151",
  null
  
)

export default component.exports